import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'

import { BeatsSortBy, ContactType } from '../../public-api'
import { ResponseModel } from '../domain/authentication.model'
import { PhotoType } from '../enums/enums'
import { CoreEnvironmentService } from './core-environment.service'

@Injectable({
  providedIn: 'root'
})
export class ProducerManagementService {
  baseUrl: string

  constructor(
    private http: HttpClient,
    private coreEnvironmentService: CoreEnvironmentService
  ) {
    this.baseUrl = this.coreEnvironmentService.getBaseURL()
  }

  upload(file: File, photoType: PhotoType) {
    const fd = new FormData()
    fd.append('file', file, file.name)
    return this.http.post<ResponseModel<{ url: string }>>(
      `${this.baseUrl}/ProdsPage/Management/UploadProdPagePhoto?type=${photoType}`,
      fd
    )
  }

  deleteImage(photoType: PhotoType) {
    return this.http.delete<ResponseModel>(`${this.baseUrl}/ProdsPage/Management/DeleteImage?type=${photoType}`)
  }

  changeDefaultBeatsSorting(defaultBeatsSorting: BeatsSortBy) {
    return this.http.post<ResponseModel>(`${this.baseUrl}/ProdsPage/Management/UpdatePageSettings`, {
      defaultBeatsSorting
    })
  }

  updateContacts(contacts: { [key: string]: ContactType[] }) {
    return this.http.post<ResponseModel>(`${this.baseUrl}/ProdsPage/Management/Contacts`, contacts)
  }
}
